import React from "react";

const Java_DataTypes_NonPrimitive = () => {
  return (
    <div>
      <h1>Java DataTypes NonPrimitive</h1>
      <p>This page provides explanations, examples, and common use-cases for Java DataTypes NonPrimitive in Java.</p>
    </div>
  );
};

export default Java_DataTypes_NonPrimitive;
